import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { Col, Empty, Row, Spin } from 'antd';
import { MainInfo } from './details/MainInfo';
import { Timetable } from './details/Timetable';
import { Configuration } from './details/Configuration';
import { NewConfiguration } from './details/NewConfiguration';
import { ExamsPanel } from './details/ExamsPanel';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTemplateDetails, fetchTemplateDetailsSuccess, resetCloneSuccess } from '../templates-actions';
import { getDetailsLoading, getEditedExam, getAddedExam } from '../templates-selector';
import styles from '../../grid/BaseGrid.module.scss';
import { HooChoices } from './details/HooChoices';

export const CloneTemplate = () => {
  const { templateId } = useParams<any>();
  const dispatch = useDispatch();
  const loading = useSelector(getDetailsLoading);
  const editedExam = useSelector(getEditedExam);
  const addedExam = useSelector(getAddedExam);

  // Shared state for new exam slot and panel visibility
  const [showNewExam, setShowNewExam] = useState(false);
  const [overrideCloneName, setOverrideCloneName] = useState<boolean>(false);
  // Ref for Timetable
  const timetableRef = useRef<any>(null);
  useEffect(() => {
    if (templateId) {
      dispatch(fetchTemplateDetails({ id: templateId }));
    }
  }, [templateId]);

  useEffect(() => {
    // Clear any previous clone success flag so we don't auto-redirect on mount
    // (previously a lingering cloneSuccess=true caused immediate navigation).
    // Dispatch the reset action to ensure reducer.cloneSuccess is false.
    dispatch(resetCloneSuccess());
  }, []);

  useEffect(() => {
    return () => {
      dispatch(fetchTemplateDetailsSuccess(null));
    };
  }, []);

  // This function will be called when the + button is clicked in ExamsPanel
  const handleAddExamClick = () => {
    setShowNewExam(true); // Show the NewExamination panel
  };

  // Handler to close NewExamination without insert
  const handleCloseNewExam = () => {
    setShowNewExam(false);
    if (timetableRef.current) timetableRef.current.removeNewSlot();
  };

  let configContent;

  if (editedExam) {
    configContent = <Configuration />;
  } else if (showNewExam && addedExam) {
    configContent = <NewConfiguration data={addedExam} onClosed={handleCloseNewExam} />;
  } else {
    configContent = <EmptyConfiguration description={<span>NO CONFIGURATION SELECTED</span>} />;
  }

  return (
    <>
      <Spin spinning={loading}>
        <Row>
          <StyledLeftCol span={12}>
            <MainInfo isClone={true} overrideCloneName={overrideCloneName} />
            <ExamsPanel onAddExam={handleAddExamClick} />
            <HooChoices overrideCloneName={overrideCloneName} onOverrideChange={setOverrideCloneName} />
            {configContent}
          </StyledLeftCol>
          <StyledRightCol span={12}>
            <Timetable ref={timetableRef} isClone={true} />
          </StyledRightCol>
        </Row>
      </Spin>
      <StyledLogoWrapper>
        <img alt='logo' className={styles['logo']} src={'./images/logo.svg'} />
      </StyledLogoWrapper>
    </>
  );
};

const StyledLeftCol = styled(Col)`
  min-width: 300px;
  padding: 10px 20px 10px;
`;

const StyledRightCol = styled(Col)`
  min-width: 150px;
  padding: 10px 20px 10px;
`;

const StyledLogoWrapper = styled.div`
  width: 100%;
  padding: 40px 40px 20px;
  display: flex;
  justify-content: flex-end;
`;

const EmptyConfiguration = styled(Empty)`
  margin-top: 100px;

  span {
    opacity: 0.6;
  }
`;
